import {
  ArrowRight,
  ChatCenteredDots,
  ChartLineUp,
  FileText,
  Globe,
  Palette,
} from '@phosphor-icons/react';
import { BRAND_CONTROL_COPY } from './landingContent';
import { useLandingReveal, usePrefersReducedMotion } from './useLandingReveal';

const INPUT_ICONS = [Globe, Palette, FileText, ChartLineUp, ChatCenteredDots];

/**
 * Generic Slack-style review mockup. Illustrative only — its action
 * chips are deliberately unfocusable because the mockup is not
 * functional.
 */
function SlackMockup() {
  return (
    <div className="lp-slack-mock" aria-hidden="true">
      <div className="lp-slack-mock__row">
        <span className="lp-slack-mock__avatar">L</span>
        <div className="lp-slack-mock__body">
          <span className="lp-slack-mock__name">
            Latted
            <span className="lp-slack-mock__badge">App</span>
          </span>
          <p className="lp-slack-mock__message">{BRAND_CONTROL_COPY.slackMessage}</p>
          <div className="lp-slack-mock__actions">
            {BRAND_CONTROL_COPY.slackActions.map((action) => (
              <span className="lp-slack-mock__action" key={action}>
                {action}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function BrandControl() {
  const reducedMotion = usePrefersReducedMotion();
  const [revealRef, revealed] = useLandingReveal();
  const visible = revealed || reducedMotion;

  return (
    <section className="lp-section lp-brand" aria-labelledby="lp-brand-heading">
      <div className="lp-container">
        <div ref={revealRef} className={`lp-reveal${visible ? ' lp-reveal--visible' : ''}`}>
          <p className="lp-label">{BRAND_CONTROL_COPY.label}</p>
          <h2 id="lp-brand-heading" className="lp-heading">
            {BRAND_CONTROL_COPY.heading}
          </h2>
          <p className="lp-body">{BRAND_CONTROL_COPY.body}</p>

          <div className="lp-brand__grid">
            <div className="lp-brand__inputs-col">
              <ul className="lp-brand__inputs">
                {BRAND_CONTROL_COPY.inputs.map((input, i) => {
                  const Icon = INPUT_ICONS[i];
                  return (
                    <li className="lp-brand__input" key={input}>
                      <span className="lp-brand__input-icon" aria-hidden="true">
                        {Icon ? <Icon size={18} /> : null}
                      </span>
                      {input}
                    </li>
                  );
                })}
              </ul>
            </div>

            <div className="lp-brand__review-col">
              <ol className="lp-brand__sequence" aria-label="Review sequence">
                {BRAND_CONTROL_COPY.sequence.map((step, i) => (
                  <li className="lp-brand__sequence-step" key={step}>
                    <span>{step}</span>
                    {i < BRAND_CONTROL_COPY.sequence.length - 1 && (
                      <ArrowRight
                        size={12}
                        weight="bold"
                        aria-hidden="true"
                        className="lp-brand__sequence-arrow"
                      />
                    )}
                  </li>
                ))}
              </ol>
              <SlackMockup />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BrandControl;
